"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import MainMenu from "../MainMenu";
import CurrenctyMegaMenu from "../CurrenctyMegaMenu";
import LanguageMegaMenu from "../LanguageMegaMenu";

import MobileMenu from "../MobileMenu";
import LOGO_LIGHT from "@/img/general/logo-light.svg";
import LOGO_DARK from "@/img/general/logo-dark.svg";
import Image from "next/image";
import { useSession } from "next-auth/react";
import { logout } from "@/lib/features/profile/profileSlice";
import { useAppDispatch } from "@/lib/hooks";
import { usePathname } from "next/navigation";
import useAuthModal from "@/hooks/useAuthModal";
import AuthModal from "@/components/common/AuthModal";
const Header1 = () => {
  const { isModalOpen, openModal, closeModal } = useAuthModal();
  const [callbackUrl, setCallbackUrl] = useState<string>("");
  const currentPage = usePathname();
  const [showCurrency, setShowCurrency] = useState(true);
  const dispatch = useAppDispatch();
  const { data: session, status } = useSession();
  // console.log("const currentUrl = window.location.href;", window.location.href)

  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY >= 10) {
        setNavbar(true);
      } else {
        setNavbar(false);
      }
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", changeBackground);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", changeBackground);
      }
    };
  }, []);

  useEffect(() => {
    if (
      currentPage === "/hotel" ||
      currentPage === "/booking" ||
      currentPage == "booking-confirmation"
    ) {
      setShowCurrency(false);
    }
  }, [currentPage]);

  return (
    <>
      <AuthModal isOpen={isModalOpen} toggle={closeModal} />
      <header className={`header bg-dark-3 ${navbar ? "is-sticky" : ""}`}>
        <div className="container header__container px-30 sm:px-20">
          <div className="row justify-between items-center">
            <div className="col-auto">
              <div className="d-flex items-center">
                <Link href="/" className="header-logo mr-20">
                  <Image
                    src={LOGO_DARK}
                    alt="logo icon"
                    width={80}
                    height={80}
                    priority={true}
                  />
                  <Image
                    src={LOGO_LIGHT}
                    alt="logo icon"
                    width={80}
                    height={80}
                    priority={true}
                  />
                </Link>
                {/* End logo */}

                {/* <div className="header-menu">
                  <div className="header-menu__content">
                    <MainMenu style="text-white" />
                  </div>
                </div> */}
                {/* End header-menu */}
              </div>
              {/* End d-flex */}
            </div>
            {/* End col */}

            <div className="col-auto">
              <div className="d-flex items-center">
                <div className="row x-gap-20 items-center">
                  {showCurrency == true && (
                    <CurrenctyMegaMenu textClass="text-white" />
                  )}
                  {/* End Megamenu for Currencty */}

                  {/* Start vertical devider*/}
                  <div className="col-auto">
                    <div className="w-1 h-20 bg-white-20" />
                  </div>
                  {/* End vertical devider*/}

                  {/* <LanguageMegaMenu textClass="text-white" /> */}
                  {/* End Megamenu for Language */}
                </div>
                {/* End language and currency selector */}

                {/* Start btn-group */}
                <div className="d-flex items-center gap-3 is-menu-opened-hide md:d-none">
                  {/* <Link
                    href="/login"
                    className="button px-30 fw-400 text-14 -white bg-white h-50 text-dark-1"
                  >
                    Become An Expert
                  </Link> */}

                  {status === "unauthenticated" ? (
                    <div
                    role="button"
                    title="Sign In / Register"
                      
                      onClick={openModal}
                      className="button px-20 fw-400 text-14 border-white -outline-white h-41 text-white ml-20 onHover"
                    >
                      Sign In / Register
                    </div>
                  ) : (
                    // <Link
                    // href={`/login?callbackUrl=${encodeURIComponent(callbackUrl)}`} // Use encodeURIComponent for safety
                    //   className="button px-30 fw-400 text-14 border-white -outline-white h-50 text-white ml-20"
                    // >
                    //   Sign In / Register
                    // </Link>
                    <>
                      <Link
                        href={`/dashboard/db-booking`}
                        className="button px-20 fw-400 text-14 border-white -outline-white h-41 text-white ml-20"
                        title="Dashboard"
                        role="button"
                      >
                        Dashboard
                      </Link>

                      <button
                       type="button"
                       title="Logout"

                        onClick={() =>
                          dispatch(logout({ url: "v1/user/logout" }))
                        }
                        className="button px-20 fw-400 text-14 border-white -outline-white h-41 text-white ml-20"
                      >
                        Logout
                      </button>
                    </>
                  )}
                </div>
                {/* End btn-group */}

                {/* Start mobile menu icon */}
                <div className="d-none xl:d-flex x-gap-20 items-center pl-30 text-white">
                  <div>
                  {status === "unauthenticated" ? (
                    <Link
                      href="/login"
                      className="d-flex items-center icon-user text-inherit text-22"
                      title="Login"
                      role="button"
                    />
                  ) : (
                    <Link
                    href={`/dashboard/db-booking`}
                      className="d-flex items-center icon-user text-inherit text-22"
                      title="Dashboard"
                      role="button"
                    />
                  )
                  }

                  </div>
                  <div>
                    <button
                      className="d-flex items-center icon-menu text-inherit text-20"
                      data-bs-toggle="offcanvas"
                      aria-controls="mobile-sidebar_menu"
                      data-bs-target="#mobile-sidebar_menu"
                      title="Mobile menu"
                    />

                    <div
                      className="offcanvas offcanvas-start  mobile_menu-contnet"
                      tabIndex={-1}
                      id="mobile-sidebar_menu"
                      aria-labelledby="offcanvasMenuLabel"
                      data-bs-scroll="true"
                      title="Mobile menu"
                    >
                      <MobileMenu />
                      {/* End MobileMenu */}
                    </div>
                  </div>
                </div>
                {/* End mobile menu icon */}
              </div>
            </div>
            {/* End col-auto */}
          </div>
          {/* End .row */}
        </div>
        {/* End header_container */}
      </header>
    </>
  );
};

export default Header1;
